import { render, staticRenderFns } from "./PublishingCompanyEditForm.vue?vue&type=template&id=b77ec0ec"
import script from "./PublishingCompanyEditForm.vue?vue&type=script&lang=js"
export * from "./PublishingCompanyEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports